import { render } from "./Auto.vue?vue&type=template&id=72f2323a&scoped=true"
import script from "./Auto.vue?vue&type=script&lang=js"
export * from "./Auto.vue?vue&type=script&lang=js"

import "./Auto.vue?vue&type=style&index=0&id=72f2323a&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f2323a"]])

export default __exports__